export const PANEL_BASE =
  "tw-absolute tw-inset-0 tw-flex tw-flex-col tw-gap-[16px] tw-px-[32px] tw-transition-[transform,opacity,visibility] tw-duration-300 tw-ease-out motion-reduce:tw-transition-none";

// `index` is the panel's own 1-based step; `step` is the active step. Panels
// behind the active one park to the left, panels ahead of it park to the right,
// so the flow always reads as a single left-to-right slide.
const panelClassName = (index: number, step: number) => {
  if (index === step) return `${PANEL_BASE} tw-visible tw-translate-x-0 tw-opacity-100`;

  const offset = index < step ? "-tw-translate-x-[40px]" : "tw-translate-x-[40px]";

  return `${PANEL_BASE} tw-invisible tw-opacity-0 ${offset}`;
};

export default panelClassName;
